import { Role, RoleContext } from '../../../setting/expert/agent/agent.const';

export class UsersConst {
  static displayColumns = () => {
    return [
      {
        title: 'Tên người dùng',
        key: 'name',
        display: true,
        allowSort: false,
        classes: '',
      },
      {
        title: 'Email',
        key: 'email',
        display: true,
        allowSort: false,
        classes: '',
      },
      {
        title: 'Chức vụ',
        key: 'display_role',
        display: true,
        allowSort: false,
        classes: '',
      },
      {
        title: 'Hoạt động',
        key: 'display_active',
        display: true,
        allowSort: false,
        classes: 'text-center',
      },
    ];
  };
  static userRoleArray = () => {
    return [
      { id: Role.Agent, text: RoleContext.Agent },
      { id: Role.Supervisor, text: RoleContext.Supervisor },
      { id: Role.Administrator, text: RoleContext.Administrator },
      { id: Role.TeamLeader, text: RoleContext.TeamLeader },
    ];
  };
  static displayRoleColumns = (user, user_id) => {
    if (user._id === user_id) {
      return `<small class="badge badge-default">Là bạn</small>`;
    }
    switch (user.role) {
      case Role.Agent:
        return `<small class="badge badge-primary">` + RoleContext.Agent + `</small>`;
      case Role.Supervisor:
        return `<small class="badge badge-info">` + RoleContext.Supervisor + `</small>`;
      case Role.Administrator:
        return `<small class="badge badge-warning">` + RoleContext.Administrator + `</small>`;
      case Role.TeamLeader:
        return `<small class="badge badge-success">` + RoleContext.TeamLeader + `</small>`;
    }
  };
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/tabs/organize/users/users.const.ts